function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#007BB5",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.388 15.8h-4.42v13.27h4.42V15.8zm.282-4.1c-.014-1.298-.951-2.29-2.465-2.29-1.5 0-2.49.992-2.49 2.29 0 1.273.95 2.291 2.437 2.291h.027c1.54 0 2.504-1.018 2.49-2.29zm6.562 5.986v-1.887h-4.406s.053 1.246 0 13.272h4.406v-7.406c0-.402.04-.79.147-1.085.322-.79 1.045-1.607 2.264-1.607 1.594 0 2.236 1.219 2.236 3v7.098h4.407v-7.607c0-4.071-2.17-5.973-5.076-5.973-2.348 0-3.396 1.286-3.978 2.195z"
}));

function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _ref);
}

export default SvgSocialLinkedin;